export const accountingPerms = [
    'xero_accounts', 
    'xero_contacts', 
    'xero_sales', 
    'xero_bank-accounts', 
    'xero_quotes', 
    'xero_purchases', 
    'xero_payments', 
    'xero_purchases_edit', 
    'xero_purchases-orders_edit', 
    'xero_inventory', 
    'xero_items_edit',
    'xero_chart-of-accounts', 
    'xero_accounts_edit', 
    'xero_reports', 
    'xero_manual-journal_edit',
    'xero_settings',
];

export const hrPerms = [
    'hr_payroll', 
    'hr_payruns', 
    'hr_loans',
    'hr_timeoff', 
    'hr_settings',
];

export const settingPerms = [
    'xero_settings', 
    'hr_settings'
];


export const userAndSubsPerms = [
    'xero_accounts', 
    'xero_contacts', 
    'xero_sales', 
    'xero_bank-accounts', 
    'xero_quotes', 
    'xero_purchases', 
    'xero_payments', 
    'xero_purchases_edit', 
    'xero_purchases-orders_edit', 
    'xero_inventory', 
    'xero_items_edit',
    'xero_chart-of-accounts', 
    'xero_accounts_edit', 
    'xero_reports', 
    'xero_manual-journal_edit',
    'xero_settings',
    'hr_payroll', 
    'hr_payruns', 
    'hr_loans',
    'hr_timeoff', 
    'hr_settings',
];

export const applicationPerms = [
    'xero_accounts', 
    'xero_contacts', 
    'xero_sales',
    'xero_sales_edit',
    'xero_reports',
    'xero_accounts_edit',
    'xero_chart-of-accounts',
    'xero_items_edit',
    'xero_inventory',
    'xero_purchases-orders_edit',
    'xero_purchases_edit',
    'xero_payments',
    'xero_purchases',
    'xero_manual-journal_edit',
    'xero_settings',
];


export const integrationPerms = [
    'xero_accounts', 
    'xero_contacts', 
    'xero_sales', 
    'xero_sales_edit', 
    'xero_payments', 
    'xero_settings', 
];
